/* PDP upsell carousel. Paired with snippets/product-upsell.liquid.

   The headline lives ABOVE the track, not inside a slide, so it has to be
   swapped in JS as the track scrolls. Each slide carries its own copy in
   data-headline, written by Liquid from the recommended product's
   upgrade.headline metafield. That is the only reason this file exists.

   Delegated click handling and a MutationObserver-free boot, because the
   block is rendered server side and never re-injected, unlike the related
   products section. shopify:section:load is handled for the theme editor. */
(function () {
  var SEL = '[data-upsell-carousel]';

  function slidesOf(card) {
    return Array.prototype.slice.call(card.querySelectorAll('[data-upsell-slide]'));
  }

  function activeIndex(track, list) {
    var mid = track.scrollLeft + track.clientWidth / 2;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < list.length; i++) {
      var centre = list[i].offsetLeft + list[i].offsetWidth / 2;
      var dist = Math.abs(centre - mid);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function sync(card) {
    var track = card.querySelector('[data-upsell-track]');
    if (!track) return;
    var list = slidesOf(card);
    if (!list.length) return;

    var i = activeIndex(track, list);

    var head = card.querySelector('[data-upsell-headline]');
    var text = list[i].getAttribute('data-headline') || '';
    if (head && text && head.textContent !== text) head.textContent = text;

    var dots = card.querySelectorAll('[data-upsell-dot]');
    for (var d = 0; d < dots.length; d++) {
      if (d === i) {
        dots[d].classList.add('is-active');
        dots[d].setAttribute('aria-current', 'true');
      } else {
        dots[d].classList.remove('is-active');
        dots[d].removeAttribute('aria-current');
      }
    }

    // Only the active slide's links and buttons are in the tab order, so a
    // keyboard user tabs through one slide and then on to the arrows and dots
    // instead of through every off-screen slide. tabindex rather than inert on
    // purpose: on desktop the next slide peeks in, and inert would also block
    // clicks on the part of it that is showing. data-upsell-untabbed marks what
    // this script changed, so it never strips a tabindex the markup set.
    // 2026-10-19 (a11y audit T6).
    for (var s = 0; s < list.length; s++) {
      var focusables = list[s].querySelectorAll('a[href], button, input, select, textarea');
      for (var f = 0; f < focusables.length; f++) {
        var el = focusables[f];
        if (s === i) {
          if (el.hasAttribute('data-upsell-untabbed')) {
            el.removeAttribute('tabindex');
            el.removeAttribute('data-upsell-untabbed');
          }
        } else if (!el.hasAttribute('tabindex')) {
          el.setAttribute('tabindex', '-1');
          el.setAttribute('data-upsell-untabbed', '');
        }
      }
    }

    var prev = card.querySelector('[data-upsell-prev]');
    var next = card.querySelector('[data-upsell-next]');
    var maxScroll = track.scrollWidth - track.clientWidth;
    if (prev) prev.hidden = track.scrollLeft <= 2;
    if (next) next.hidden = track.scrollLeft >= maxScroll - 2;
  }

  function scrollToIndex(card, index) {
    var track = card.querySelector('[data-upsell-track]');
    var list = slidesOf(card);
    if (!track || !list[index]) return;
    track.scrollTo({ left: list[index].offsetLeft - list[0].offsetLeft, behavior: 'smooth' });
  }

  function step(card, dir) {
    var track = card.querySelector('[data-upsell-track]');
    var list = slidesOf(card);
    if (!track || list.length < 2) return;
    scrollToIndex(card, Math.min(list.length - 1, Math.max(0, activeIndex(track, list) + dir)));
  }

  function init(card) {
    if (card.getAttribute('data-upsell-ready') === 'true') return;
    card.setAttribute('data-upsell-ready', 'true');
    var track = card.querySelector('[data-upsell-track]');
    if (!track) return;
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        sync(card);
      });
    }, { passive: true });
    sync(card);
  }

  function boot() {
    var cards = document.querySelectorAll(SEL);
    for (var i = 0; i < cards.length; i++) init(cards[i]);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var hit = e.target.closest('[data-upsell-prev],[data-upsell-next],[data-upsell-dot]');
    if (!hit) return;
    var card = hit.closest(SEL);
    if (!card) return;
    e.preventDefault();
    if (hit.hasAttribute('data-upsell-dot')) {
      scrollToIndex(card, parseInt(hit.getAttribute('data-upsell-dot'), 10) || 0);
    } else {
      step(card, hit.hasAttribute('data-upsell-next') ? 1 : -1);
    }
  });

  window.addEventListener('resize', function () {
    var cards = document.querySelectorAll(SEL);
    for (var i = 0; i < cards.length; i++) sync(cards[i]);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
